/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { tv } from 'tailwind-variants';
import { getTestProps } from 'lib/testing/utils';
import BoardMemberItem from 'helpers/BoardMember/BoardMemberCard';
import { withStandardComponentWrapper } from 'helpers/HOC';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const BoardMembers = (props)=>{
    const isEditing = useIsEditing();
    const { container, listWrapper } = TAILWIND_VARIANTS();
    const boardMembers = props?.fields?.boardMembersList;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: (boardMembers?.length ?? 0) > 0 && /*#__PURE__*/ _jsx("div", {
            "data-component": "authorable/shared/content/boardmembers",
            ...editingHydrationProps(isEditing),
            ...getTestProps(`component-Board-Members-${props?.rendering?.uid}`),
            children: /*#__PURE__*/ _jsx("div", {
                className: container(),
                children: /*#__PURE__*/ _jsx("div", {
                    className: listWrapper(),
                    children: boardMembers?.map((item, index)=>/*#__PURE__*/ _jsx(BoardMemberItem, {
                            ...item
                        }, item.id ?? index))
                })
            })
        })
    });
};
export const Default = withStandardComponentWrapper(BoardMembers);
const TAILWIND_VARIANTS = tv({
    slots: {
        container: [
            'w-full',
            'flex',
            'flex-col',
            'gap-component-section-container-gutter'
        ],
        listWrapper: [
            'w-full',
            'flex flex-col lg:flex-row lg:flex-wrap justify-center lg:items-stretch lg:justify-items-stretch',
            'gap-y-component-section-container-gutter gap-x-spacing-spacing-24'
        ]
    }
});
